import { requestApi, requestUploader } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const filePreData = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Media/FilePreData",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const filePreviewDetail = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Media/FilePreviewDetail",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const fileInheritedDetail = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Media/FileInheritedDetail",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const editorFileInfo = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Media/EditorFileInfo",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const uploader = ({ file, params, store }) => {
  return new Promise(resolve => {
    //console.log(file);
    requestUploader({
      //api: "Media/uploader",
      file: file,
      //method: "post",
      params: params
      //data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const boxInAttachmentList = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Media/BoxInAttachmentList",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
